"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lamportsToSol = exports.shortenAddress = exports.detectInvalidPubKeys = exports.isValidPublicKey = void 0;
const bs58_1 = __importDefault(require("bs58"));
const isValidPublicKey = (pubkey) => {
    try {
        return bs58_1.default.decode(pubkey).length === 32;
    }
    catch (_a) {
        return false;
    }
};
exports.isValidPublicKey = isValidPublicKey;
const detectInvalidPubKeys = (keys) => {
    const invalidKeys = [];
    for (const key of keys) {
        if (!(0, exports.isValidPublicKey)(key)) {
            invalidKeys.push(key);
        }
    }
    return invalidKeys;
};
exports.detectInvalidPubKeys = detectInvalidPubKeys;
const shortenAddress = (pubkey) => {
    if (!(0, exports.isValidPublicKey)(pubkey)) {
        return '';
    }
    return `${pubkey.slice(0, 4)}...${pubkey.slice(-4)}`;
};
exports.shortenAddress = shortenAddress;
const lamportsToSol = (lamports) => lamports / 10 ** 9;
exports.lamportsToSol = lamportsToSol;
